import $ from '../vendor/jquery';

$('figcaption .trigger').click(function(e) {
  e.preventDefault();

  if ($(this).hasClass('open')) {
    $(this).removeClass('open');
  } else {
    $(this).addClass('open');
  }
  $(this).siblings('.caption').slideToggle();
});

$('.zoom-image a').magnificPopup({ type: 'image' });



// WEBPACK FOOTER //
// ./public/assets/js/src/components/images.js